import { getNoMatchContent } from "./getNoMatchContent";
import { defaultRowsPerPage, rowsPerPageOptions as defaultRowsPerPageOptions } from "./consts";

export const tableOptionsDefaults = {
  responsive: "simple",
  print: false,
  download: false,
  viewColumns: false,
  search: false,
  filter: false,
  selectableRows: "none",
  elevation: 0,
  serverSide: true,
  rowsPerPage: defaultRowsPerPage,
  rowsPerPageOptions: defaultRowsPerPageOptions,
};

const onlyDefined = (obj) =>
  Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== undefined) acc[key] = obj[key];
    return acc;
  }, {});

export const buildTableOptions = ({ loading = false, downloadFilename, textLabels, ...options }) => ({
  ...tableOptionsDefaults,
  ...onlyDefined(options),
  ...(downloadFilename !== undefined ? { downloadOptions: { filename: downloadFilename } } : {}),
  textLabels: {
    ...textLabels,
    body: { noMatch: getNoMatchContent(loading), ...textLabels?.body },
  },
});
